import { render, staticRenderFns } from "./Ckeditor4.vue?vue&type=template&id=667dca7a&scoped=true&"
import script from "./Ckeditor4.vue?vue&type=script&lang=js&"
export * from "./Ckeditor4.vue?vue&type=script&lang=js&"
import style0 from "./Ckeditor4.vue?vue&type=style&index=0&id=667dca7a&lang=scss&scoped=true&"
import style1 from "./Ckeditor4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dca7a",
  null
  
)

export default component.exports